// extracted by mini-css-extract-plugin
module.exports = {"serviceWrapper":"services_serviceWrapper__3Q6pc","serviceItem":"services_serviceItem__1Wmly","serviceItemImage":"services_serviceItemImage__1Xq4D"};